/**
 * @generated SignedSource<<317366a1f6ba53f745684c3a5a1d0a68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistPortfolioPage_offers$data = ReadonlyArray<{
  readonly monthlyEarnings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "MonthlyEarningsNode";
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "ArtistPortfolioPage_offers";
}>;
export type ArtistPortfolioPage_offers$key = ReadonlyArray<{
  readonly " $data"?: ArtistPortfolioPage_offers$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistPortfolioPage_offers">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ArtistPortfolioPage_offers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MonthlyEarningsNodeConnection",
      "kind": "LinkedField",
      "name": "monthlyEarnings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MonthlyEarningsNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MonthlyEarningsNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OfferNode",
  "abstractKey": null
};

(node as any).hash = "f38d69d731d58578453402b720e89a0b";

export default node;
